export default {
  path:    window._data.taxon_path,
  current: window._data.taxon_path,
  state: false,
  style: {}
}